import { FormConfig } from '../edit-create-form.interfaces';
import { SETTING_TYPE_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';
import { SETTING_COLOR_PRESET_CONFIG } from '@shared/components/generic-colorpreset/generic-colorpreset.configs';
import { SETTING_BG_COLOR_CONFIG, SETTING_TEXT_COLOR_CONFIG, SETTING_BG_CHILD_COLOR_CONFIG } from '@shared/components/generic-colorpicker/generic-colorpicker.configs';

export const settingFormConfig = (): FormConfig => {
  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'code', label: 'Mã', required: true, width: 'half',
        type: 'text', placeholder: 'Nhập mã tag',
        disabled: (editMode) => editMode
      },
      {
        key: 'name', label: 'Tên', required: true, width: 'half',
        type: 'text', placeholder: 'Nhập tên tag'
      },
      {
        key: 'type', label: 'Loại', required: true, width: 'full',
        type: 'select',
        config: { ...SETTING_TYPE_SELECT_CONFIG }
      },
      {
        key: 'colorPreset',
        label: 'Bộ màu có sẵn',
        type: 'colorpreset',
        width: 'full',
        config: SETTING_COLOR_PRESET_CONFIG,
        showDividerAfter: true
      },
      {
        key: 'bgColor',
        label: 'Màu nền',
        required: true,
        type: 'colorpicker',
        width: 'half',
        config: SETTING_BG_COLOR_CONFIG,
        dependsOn: 'colorPreset'
      },
      {
        key: 'textColor',
        label: 'Màu chữ',
        required: true,
        type: 'colorpicker',
        width: 'half',
        config: SETTING_TEXT_COLOR_CONFIG,
        dependsOn: 'colorPreset'
      },
      {
        key: 'bgChildColor',
        label: 'Màu nền con',
        type: 'colorpicker',
        width: 'full',
        config: SETTING_BG_CHILD_COLOR_CONFIG
      }
    ]
  };
};

